export const unslickFooter = () => {
  jQuery('.slick-footer-links').slick('unslick');
  jQuery('.slick-footer-links').slick({
    infinite: !0,
    dots: !0,
    arrows: !1,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 4,
    useCSS: !0,
    useTransform: !0,
    responsive: [{
      breakpoint: window.decathlon.uxBreakpoints.smMin,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: window.decathlon.uxBreakpoints.xxsMin,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
};

export const redirectCountryLinks = () => {
  jQuery('.block-footer select').change( function redirect() {
    const option = jQuery('option:selected', this).attr('value');
    if (typeof option !== 'undefined' && option !== ''){
      window.open(option, '_blank');
    }
  });
};



// WEBPACK FOOTER //
// ./src/_override/shared/footer/footer.js